export default __webpack_public_path__ + "static/media/Chapperone-font-v1.65b6a809.jpg";